import { useContext, useEffect, useMemo, useState } from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import * as FEATURES from '../../../../constants/features'
import * as SETTINGS from '../../../../constants/settings'
import { SiteConfigContext } from '../../../../context/siteConfigContext'
import { toastSuccess } from '../../../../utils/toast'
import Tooltip from '../../../Utilities/Tooltip'
import './styles.css'

const LimitedAccessSettings = () => {
  const {
    [SETTINGS.FEATURES.key]: enabledFeatures,
    [SETTINGS.LIMITED_ACCESS.key]: limitedAccess,
    updateSetting
  } = useContext(SiteConfigContext)
  const [tmpGuide, setTmpGuide] = useState(limitedAccess.copy)
  const [tmpChat, setTmpChat] = useState(limitedAccess.chat)

  useEffect(() => {
    setTmpGuide(limitedAccess.copy)
    setTmpChat(limitedAccess.chat)
  }, [limitedAccess])

  const limitedAccessEnabled = useMemo(
    () => enabledFeatures && enabledFeatures[FEATURES.LIMITED_ACCESS],
    [enabledFeatures]
  )

  const handleSubmit = async (e) => {
    e.preventDefault()
    await updateSetting(SETTINGS.LIMITED_ACCESS, {
      ...limitedAccess,
      copy: tmpGuide,
      chat: tmpChat
    })
    toastSuccess('Limited Access content saved!')
  }

  if (!limitedAccessEnabled) {
    return (
      <div className="flex flex-col gap-2">
        <h2>Limited Access mode is not enabled</h2>
      </div>
    )
  }

  return (
    <form
      onSubmit={handleSubmit}
      autoComplete="off"
      className="flex flex-col gap-2"
    >
      <div className="flex items-center gap-2">
        <h2 className="mr-3">Limited Access Content</h2>
        <Tooltip>
          Edit the free mode content displayed on your headquarters page.
        </Tooltip>
      </div>
      <label
        className="block text-sm font-medium text-gray-700 dark:text-white"
        htmlFor="limitedAccess"
      >
        Closed Stream Copy
      </label>
      <ReactQuill
        id="limitedAccess"
        name="limitedAccess"
        style={{ height: '420px', width: '100%' }}
        aria-label="Limited Access content"
        placeholder="Limited Access content"
        value={tmpGuide}
        onChange={setTmpGuide}
        modules={{
          toolbar: [
            [{ header: [1, 2, false] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['link'],
            ['clean']
          ]
        }}
        formats={[
          'header',
          'bold',
          'italic',
          'underline',
          'strike',
          'blockquote',
          'list',
          'bullet',
          'link'
        ]}
      />
      <label
        className="block text-sm font-medium text-gray-700 dark:text-white"
        htmlFor="chatreplacement"
      >
        Chat Replacement Copy (150 characters)
      </label>
      <input
        id="chatreplacement"
        value={tmpChat}
        onChange={(e) => setTmpChat(e.target.value)}
        className="input block w-full"
        placeholder={tmpChat}
        maxLength={150}
      />
      <button type="submit" aria-label="Save" className="button-confirm w-fit">
        Save
      </button>
    </form>
  )
}

export default LimitedAccessSettings
